let inject = ['$scope', '$uibModalInstance','modalOptions', 'SharedService'];

class ModalDriverController {
  constructor ($scope,$uibModalInstance,modalOptions, SharedService) {
    this.$scope = $scope;
    this.SharedService = SharedService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
    this.vehiculo_transporte = this.modalOptions.vehiculo_transporte;
  }

  updateInformation (despachoPedido) {
    this.SharedService.updateDespachoPedido(despachoPedido).then(response => {
      this.ok();
    }).catch(reason => {
      this.cancel();
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close();
  }
}

ModalDriverController.$inject = inject;

export default ModalDriverController;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/components/modal-driver/modal-driver.controller.js
 **/